module.exports = __webpack_public_path__ + "media/Chicken.746ebab3.ogg";